import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import "../css/ursb-inbox.css"
import { DownloadIcon, PDFIcon } from '../../../../asset-controller-mod/asset-serv/icons/iconExporter';
import { Button } from '@core/uilibrary';

export const STATUS_OPTIONS = [
    { value: "all-status", label: "All status" },
    { value: "published", label: "Published" },
    { value: "unpublished", label: "Unpublished" },
    { value: "draft", label: "Draft" },
];

type InboxFile = {
    name: string;
    sizeLabel?: string;
    url?: string;
};

export interface UsrbInboxProps {
    fullname: string;
    type: string;
    email: string;
    phone: string;
    message: string;
    status?: string;
    file?: InboxFile;
    onBack?: () => void;
}

const UrsbInbox: FC<UsrbInboxProps> = ({
    fullname,
    type,
    email,
    phone,
    message,
    status,
    file,
    onBack,
}) => {
    const initialStatus = useMemo(() => {
        return status && STATUS_OPTIONS.some(o => o.value === status) ? status : "all-status";
    }, [status]);

    const [statusFilter, setStatusFilter] = useState<string>(initialStatus);    

    useEffect(() => {
        setStatusFilter(initialStatus);
    }, [initialStatus]);

    const forceDownload = useCallback(async (url: string, filename: string) => {
        try {
            const res = await fetch(url, { credentials: "include" });
            if (!res.ok) throw new Error(`Download failed (${res.status})`);

            const blob = await res.blob();
            const blobUrl = globalThis.window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename || "download";
            document.body.appendChild(a);
            a.click();
            a.remove();

            globalThis.window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error(err);
            // optional: show toast if you have it in sidebar
        }
    }, []);

    return (
        <section className="scl--ursb-inbox-const-styl-box">
            <div className="scl--ursb-item-content-styl ocasion">
                <div className="scl--ursb-spec-sm-item">
                    <span>Full name :</span>
                    <h6>{fullname}</h6>
                </div>

                <div className="scl--ursb-spec-sm-item">
                    <span>Type</span>
                    <h6>{type}</h6>
                </div>
            </div>

            <div className="scl--ursb-item-content-styl normal">
                <span>Email</span>
                <h6>{email}</h6>
            </div>

            <div className="scl--ursb-item-content-styl normal">
                <span>Phone</span>
                <h6>{phone}</h6>
            </div>

            <div className="scl--ursb-item-content-styl normal">
                <span>Attached file</span>

                <div className="scl--ursb-file-display-styl">
                    {file ? (
                        <>
                            <PDFIcon />
                            <div className="scl--ursb-file-ds-title">
                                <h5>{file.name}</h5>
                                <div className="span-mock">{file.sizeLabel ?? "-"}</div>
                            </div>

                            <button
                                type="button"
                                onClick={() => {
                                    if (file?.url) forceDownload(file.url, file.name);
                                }}
                                disabled={!file?.url}
                            >
                                <DownloadIcon />
                            </button>
                        </>
                    ) : (
                        <div className='no-file'>
                            No file were attached
                        </div>
                    )}
                </div>
            </div>

            <div className="scl--ursb-item-content-styl normal">
                <span>Message</span>
                <div className="message-box">{message}</div>
            </div>

            <div className="scl--ursb-btn-decision-styl">
                <Button value="Back" variant="ghost" onClick={onBack} />
            </div>
        </section>
    );
};

export default UrsbInbox